<div class="content-container store" *ngIf="allProductCount > 0; else storeWelcome">
  <section class="data-table" *ngIf="showProduct; else addOns">
    <header class="data-table__header">
      <h2 class="page-heading tab-content-header active" id="products-content-header">
        <ng-container i18n="@@my_products">My Products</ng-container>
      </h2>
      <div class="d-flex">
        <button href="javascript:void(0)" class="d-flex add_new_invoice_btn mr-2" (click)="openAddProductModal()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <ng-container i18n="@@products.add_new_product">Add New</ng-container>
        </button>
        <button href="javascript:void(0)" class="d-flex add_new_invoice_btn mr-2" (click)="openAddOns()" *ngIf="!isFoodics">
          <ng-container i18n="@@products.addons">Addons</ng-container>
        </button>
      </div>
    </header>

    <div class="data-table__wrap">
      <header class="data-table__controls">
          <!-- <div class="back-icon">
              <a href="#" id="go-back" class="tu-btn-circular transparent"><i></i></a>
          </div> -->
          <div class="select-date-from select-pages">
              <div class="select-pages_tabs">
                  <ul class="tabs_content">
                      <li class="tab_item" data-target="all-products" (click)="filterByCategory()" [ngClass]="{active: isActive(null)}">
                        <ng-container i18n="@@common.all">All</ng-container> ({{ allProductCount }})
                      </li>
                      <ng-container *ngIf="categories.length > 0">
                        <li class="tab_item" *ngFor="let category of categories" (click)="filterByCategory(category)" [ngClass]="{active: isActive(category.id)}">
                          {{ locale == 'ar' ? (category.name_ar || (category.name | titlecase)) : (category.name | titlecase) }} ({{ category.products_count }})
                        </li>
                      </ng-container>
                  </ul>
              </div>
          </div>

          <div class="filters_block">
            <svg class="search_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input type="text" class="filters_search" (keyup)="searchProducts($event.target.value)" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />

            <div class="filters_btn_wrap">
              <!-- <button class="clear_allfilters saved_filters">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Clear saved filters
              </button> -->

              <button class="btn btn-sm" (click)="triggerSave()" *ngIf="showSaveButton" i18n="@@products.save_changes">
                Save Changes
              </button>

              <button class="filters_block_btn filters_options" (click)="toggleFilters()">
                  <svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 12H18M3 6H21M9 18H15" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <ng-container i18n="@@filter.filters">Filters</ng-container> <span class="selected_filters2"></span>
              </button>

              <button class="filters_block_btn filter_import" (click)="openImportModal()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M21 21H3M18 11L12 17M12 17L6 11M12 17V3" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span i18n="@@products.import_xls">Import .xlx</span>
              </button>

              <button class="filters_block_btn filter_export" (click)="exportXls()">
                <svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 3H3M18 13L12 7M12 7L6 13M12 7V21" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span i18n="@@products.export">Export</span>
              </button>

              <div class="d-flex align-center grid-table-toggle">
                <svg class="changeToList show" width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="displayView('grid')">
                    <path d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H47.5V39.5H8C3.85787 39.5 0.5 36.1421 0.5 32V8Z" fill="white"/>
                    <path d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H47.5V39.5H8C3.85787 39.5 0.5 36.1421 0.5 32V8Z" stroke="#E0E0E0"/>
                    <path d="M24 14C24.5523 14 25 13.5523 25 13C25 12.4477 24.5523 12 24 12C23.4477 12 23 12.4477 23 13C23 13.5523 23.4477 14 24 14Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M24 21C24.5523 21 25 20.5523 25 20C25 19.4477 24.5523 19 24 19C23.4477 19 23 19.4477 23 20C23 20.5523 23.4477 21 24 21Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M24 28C24.5523 28 25 27.5523 25 27C25 26.4477 24.5523 26 24 26C23.4477 26 23 26.4477 23 27C23 27.5523 23.4477 28 24 28Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M31 14C31.5523 14 32 13.5523 32 13C32 12.4477 31.5523 12 31 12C30.4477 12 30 12.4477 30 13C30 13.5523 30.4477 14 31 14Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M31 21C31.5523 21 32 20.5523 32 20C32 19.4477 31.5523 19 31 19C30.4477 19 30 19.4477 30 20C30 20.5523 30.4477 21 31 21Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M31 28C31.5523 28 32 27.5523 32 27C32 26.4477 31.5523 26 31 26C30.4477 26 30 26.4477 30 27C30 27.5523 30.4477 28 31 28Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 21C17.5523 21 18 20.5523 18 20C18 19.4477 17.5523 19 17 19C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 28C17.5523 28 18 27.5523 18 27C18 26.4477 17.5523 26 17 26C16.4477 26 16 26.4477 16 27C16 27.5523 16.4477 28 17 28Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg class="changeToTable show" width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="displayView('table')">
                    <mask id="path-1-inside-1_62_44956" fill="white">
                    <path d="M0 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H0V0Z"/>
                    </mask>
                    <path d="M0 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H0V0Z" fill="#FAFAFA"/>
                    <path d="M0 -1H40C44.9706 -1 49 3.02944 49 8H47C47 4.13401 43.866 1 40 1H0V-1ZM49 32C49 36.9706 44.9706 41 40 41H0V39H40C43.866 39 47 35.866 47 32H49ZM0 40V0V40ZM40 -1C44.9706 -1 49 3.02944 49 8V32C49 36.9706 44.9706 41 40 41V39C43.866 39 47 35.866 47 32V8C47 4.13401 43.866 1 40 1V-1Z" fill="#E0E0E0" mask="url(#path-1-inside-1_62_44956)"/>
                    <path d="M33 20L21 20M33 14L21 14M33 26L21 26M17 20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19C16.5523 19 17 19.4477 17 20ZM17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13C16.5523 13 17 13.4477 17 14ZM17 26C17 26.5523 16.5523 27 16 27C15.4477 27 15 26.5523 15 26C15 25.4477 15.4477 25 16 25C16.5523 25 17 25.4477 17 26Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

            </div>
          </div>

          <div class="filters_expanded">

            <h3 class="filters_expanded_header"> <ng-container i18n="@@filter.filters">Filters</ng-container></h3>
            <!-- <div class="checkbox_cont">
              <div class="custom-checkbox filters_checkbox">
                <input id="filters_checkbox" type="checkbox" class="select-item orders_inputAll">
                <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
                </svg>
                <svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
                  <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span>Remember for the next time</span>
            </div> -->
            <div class="filters_expanded_bottom">
              <div class="total_wrap">
                <span class="date_title" i18n="@@filter.price">Price</span>
                <div class="total_cont">
                  <label i18n="@@filter.from">from</label> <input type="text" [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="100"/>
                  <label i18n="@@filter.to">to</label> <input type="text" [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="10,000"/>
                </div>
              </div>
              <div class="status_wrap">
                <span class="date_title" i18n="@@filter.discount">Discount</span>
                <div class="radio-group d-flex justify-content-start align-items-center gap-5 flex-none-column align-items-none-start" id="discount-type">
                  <div class="d-flex align-items-center gap-3">
                    <input type="radio" id="discount1" name="discount-type" class="custom-radio" value="yes" [(ngModel)]="discountApplies" (change)="filterByDiscount()" >
                    <label class="m-0" for="discount1" i18n="@@filter.discount_applies">Discount Applies</label>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <input type="radio" id="discount2" name="discount-type" class="custom-radio" value="no" [(ngModel)]="discountApplies" (change)="filterByDiscount()">
                    <label class="m-0" for="discount2" i18n="@@filter.no_discount">No discount</label>
                  </div>
                </div>
              </div>

              <!-- <div class="status_wrap">
                <span class="date_title">Status</span>
                <div class="radio-group d-flex justify-content-start align-items-center gap-5 flex-none-column align-items-none-start" id="status-type">
                  <div class="d-flex align-items-center gap-3">
                    <input type="radio" id="status-type1" name="status-type" class="custom-radio">
                    <label class="m-0" for="status-type1">Discount Applies</label>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <input type="radio" id="status-type2" name="status-type" checked class="custom-radio">
                    <label class="m-0" for="status-type2">No discount</label>
                  </div>
                </div>
              </div> -->

              <button class="clear_allfilters" (click)="resetAmountFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <ng-container i18n="@@filter.clear_all">Clear all</ng-container>
              </button>

            </div>
          </div>
      </header>


      <!-- <header class="data-table__create-section">
        <div class="search-field">
          <div class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
              <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
                <circle cx="7" cy="7" r="7" />
                <path stroke-linecap="square" d="M13.5 12.5L18 17" />
              </g>
            </svg>
          </div>
          <input type="text" (keyup)="searchProducts($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />
        </div>
        <div class="create-download">
          <a href="javascript:void(0)" data-toggle="modal" id="add-product-btn" product-modal="service-list" data-target="#add-product-services" class="tu-btn pink add-button" (click)="openAddProductModal()" i18n="@@products.add_new_product" >
            Add New Product
          </a>
        </div>
      </header> -->

      <header class="data-table__controls">
        <!-- <select class="select-link" id="tab-links-select">
          <option value="0" >
            <ng-container i18n="@@common.all">All</ng-container> ({{allProductCount}})
          </option>
          <option *ngFor="let category of categories">{{ category.name | titlecase }} ({{ category.products_count }})</option>
        </select>
        <ul class="nav nav-pills" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" id="pills-design-pill" data-toggle="pill" href="javascript:void(0)" role="tab" aria-controls="pills-design-service" aria-selected="false" (click)="filterByCategory()" [ngClass]="{active: isActive(null)}">
              <ng-container i18n="@@common.all">All</ng-container> ({{ allProductCount }})
            </a>
          </li>
          <ng-container *ngIf="categories.length > 0">
            <li class="nav-item" *ngFor="let category of categories">
              <a class="nav-link" id="pills-design-pill" data-toggle="pill" href="javascript:void(0)" role="tab" aria-controls="pills-design-service" aria-selected="false" (click)="filterByCategory(category)" [ngClass]="{active: isActive(category.id)}">
                {{ category.name | titlecase }} ({{ category.products_count }})
              </a>
            </li>
          </ng-container>
        </ul> -->

        <!-- <div class="data-table__btn-wrap">
          <div class="btn-row">
            <a href="javascript:;" (click)="openImportModal()" class="downloadXl" style="padding: 14px 14px !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
                <g fill="#0CC5D1" fill-rule="evenodd">
                  <path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
                  <path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
                </g>
              </svg>
              <span>Import .xls</span>
            </a>
          </div>
        </div> -->

        <!-- <div class="data-table__btn-wrap">
          <a href="#" id="update-payment" class="tu-btn-circular pink outline">
            <svg width="16" height="12" viewBox="0 0 16 12">
              <path stroke-width="2" d="M1 5.667l4.667 4.666L15 1"/>
            </svg>
          </a>
          <div class="btn-row">
            <form class="data-table__search" [class.open]="isSearch">
              <input type="text" (keyup)="searchProducts($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />
              <a href="javascript:void(0)" id="search-open" (click)="toggleSearch()">
                <svg width="20" height="19" viewBox="0 0 20 19">
                  <g class="svg-stroke" fill="none" fill-rule="evenodd" stroke-width="1.5" transform="translate(1 1)">
                    <circle cx="7" cy="7" r="7" />
                    <path stroke-linecap="square" d="M13.5 12.5L18 17" />
                  </g>
                </svg>
              </a>
              <svg id="search-close" width="15" height="15" class="close-icon" version="1.1" x="0px" y="0px" viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve" (click)="toggleSearch()">
                <path class="svg-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
              </svg>
            </form>
            <a href="javascript:void(0)" data-toggle="modal" id="add-product-btn" product-modal="service-list" data-target="#add-product-services" class="tu-btn-circular pink add-button" (click)="openAddProductModal()" >
              <svg width="14" height="14" viewBox="0 0 14 14">
                <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
                  <path d="M1 7h12M7 1v12" />
                </g>
              </svg>
            </a>
          </div>
        </div> -->
      </header><!-- end header -->

      <div class="tab-content data-table__tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active pb-4" id="pills-all-store" role="tabpanel" aria-labelledby="pills-all-store-tab">
          <div id="all_products_table" style="width: 100%">
            <ng-container *ngIf="products && products.length > 0; else noRecord">
              <ng-container *ngIf="listView == 'table'; else gridView">
                <product-table
                  [myProducts]="products"
                  [paginator]="paginator"
                  (onEditProduct)="onEditProduct()"
                  (onDelete)="onDeleteProduct($event)"
                  (onStatusChange)="onStatusChange($event)"
                  (onSelect)="onSelectProduct($event)"
                  [isProductSelected]="isProductSelected"
                  (hasChanges)="onChildHasChanges($event)">
                </product-table>
              </ng-container>

              <ng-template #gridView>
                <product-grid
                  [myProducts]="products"
                  [paginator]="paginator"
                  (onEditProduct)="onEditProduct()"
                  (onDelete)="onDeleteProduct($event)"
                  (onStatusChange)="onStatusChange($event)"
                  (onSelect)="onSelectProduct($event)"
                  [isProductSelected]="isProductSelected">
                </product-grid>
              </ng-template>
            </ng-container>

            <ng-template #noRecord>
              <div class="tab-content data-table__tab-content">
                <ng-container *ngIf="loading; else noRecord" i18n="@@common.loading">Loading...</ng-container>
                <ng-template #noRecord>
                  <ng-container i18n="@@common.no_record_found">No record found.</ng-container>
                </ng-template>
              </div>
            </ng-template>
          </div>

          <!-- paginator  -->
          <ng-container *ngIf="paginator.totalItems > paginator.itemsPerPage">
            <div class="pagination_wrapper">
              <div class="showing_results">
                <div class="results_list" *ngIf="paginator?.from || paginator?.to">
                  Showing from {{ paginator?.from }} to {{ paginator?.to }} of {{ paginator?.totalItems }} items
                </div>
              </div>
              <nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)" aria-label="...">

                <ul class="pagination justify-content-center">
                  <li class="page-item" [class.disabled]="p.isFirstPage()">
                    <a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
                      <svg width="7.5" height="13.5">
                        <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                      </svg>
                    </a>
                  </li>
                  <li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
                    <a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
                      <span>{{ page.label }}</span>
                    </a>
                    <a *ngIf="p.getCurrent() === page.value" class="page-link">
                      {{page.label}}
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>

                  <li class="page-item" [class.disabled]="p.isLastPage()">
                    <a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
                      <svg width="7.5" height="13.5">
                        <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </ng-container>
          <!-- paginator  -->

        </div>
      </div>
    </div><!-- end data-table__wrap -->
  </section><!-- end data-table -->
  <ng-template #addOns>
    <app-modifier class="w-100" (notifyParent)="closeAddOns()"></app-modifier>
  </ng-template>
</div>

<ng-template #storeWelcome>
  <store-welcome *ngIf="initialized" [type]="'product'" (onAddClick)="openAddProductModal()"></store-welcome>
</ng-template>

<div class="selected_items_options" *ngIf="isProductSelected">
  <button class="filters_block_btn delete_product_item text-danger" (click)="deleteProducts()">
      <svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <ng-container i18n="@@products.delete">Delete</ng-container>
  </button>
</div>
